import React from 'react'
import { Icon, SemanticICONS } from 'semantic-ui-react'

import styles from './phatButton.module.scss'

const ColorClasses = {
  none: '',
  green: styles.green,
  orange: styles.orange,
  red: styles.red,
  blue: styles.blue,
  purple: styles.purple,
}

export type ButtonColor = keyof typeof ColorClasses

type Props = {
  children?: React.ReactNode
  onClick?: (e: React.MouseEvent) => void
  className?: string
  disabled?: boolean
  type?: 'button' | 'submit' | 'reset'
  color?: ButtonColor
  style?: React.CSSProperties
  icon?: SemanticICONS
  title?: string
  tabIndex?: number
  id?: string
}

const PhatButton = ({
  children = null,
  onClick,
  className = '',
  color = 'none',
  disabled = false,
  type,
  style,
  icon,
  title,
  tabIndex,
  id,
}: Props) => (
  <button
    id={id}
    style={style}
    className={`${styles.button} ${ColorClasses[color]} ${className}`}
    onClick={onClick}
    disabled={disabled}
    type={type}
    title={title}
    tabIndex={tabIndex}>
    {icon && <Icon name={icon} />}
    {children}
  </button>
)

export default PhatButton
